const RankStarFullOrange = ({ className }: { className: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none" className={className}>
    <path
      fill="#ffbf66"
      stroke="#ffbf66"
      strokeWidth="1.5"
      d="m9 11.3 3.71 2.7-1.42-4.36L15 7h-4.55L9 2.5 7.55 7H3l3.71 2.64L5.29 14 9 11.3z"
      className="color000000 svgShape"
    />
  </svg>
);

export default RankStarFullOrange;
